<div class="example-container">
  <table mat-table #itemsList
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mat-elevation-z8 mat-table-custom" id="contractbundle">

    <ng-container matColumnDef="arrow">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element"
        (click)="pushPopElement(element)">
        @if (checkExpanded(element)) {
          <span class="material-icons" matTooltip="Collapse">
            expand_less
          </span>
        } @else {
          <span class="material-icons" matTooltip="More Details">
            expand_more
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="bundle">
      <th mat-header-cell *matHeaderCellDef> Bundle </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.Bundle"></p>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element; let i = dataIndex">
        <button mat-icon-button matTooltip="Translation Audit History"
          (click)="openAuditHistory(element.BundleId, element.Bundle)">
          <mat-icon>history</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Delete Bundle"
          (click)="deleteBundle(element.BundleId)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div [@detailExpand]="checkExpanded(element) ? 'expanded' : 'collapsed'">
          <table mat-table [dataSource]="element.BundleList" class="mat-subtable-custom" id="bundlelist">

            <ng-container matColumnDef="feature">
              <th mat-header-cell *matHeaderCellDef> Generic Feature </th>
              <td mat-cell *matCellDef="let feature">
                <p [innerHTML]="feature.Feature"></p>
              </td>
            </ng-container>

            <ng-container matColumnDef="localContractLine">
              <th mat-header-cell *matHeaderCellDef> Local Contract Translation </th>
              <td mat-cell *matCellDef="let feature">
                <input class="local-contract-input" id="localContractLine_{{feature.FeatureId}}"
                  [(ngModel)]="feature.LocalContractLine"
                  placeholder="Enter local translation">
              </td>
            </ng-container>

            <ng-container matColumnDef="featureActions">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let feature">
                <button mat-icon-button matTooltip="Save Translation"
                  (click)="saveTranslation(feature)">
                  <mat-icon>save</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let element2; let i2 = index; columns: subcolumnsToDisplay;"
            class="subitem"></tr>
          </table>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
      class="item">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-subitem"></tr>

  </table>
</div>


